import observers from './observers';

export default function observe(observer) {
	observers.add(observer);
	return () => observers.delete(observer);
}
